<template>
  <p v-if="forbidden" class="p-6 text-gray-600" data-cy="imports-forbidden">
    You don't have access to imports.
  </p>
  <ImportsHub
    v-else-if="initialData"
    :source="initialData.source"
    :tabs="initialData.tabs"
    :new-imports="initialData.new_imports"
  />
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";

import type { NewImportType } from "@/DataImports/flow/types";
import ImportsHub from "@/DataImports/ImportsHub.vue";
import type { HubTab } from "@/DataImports/importsHubRows";

const initialData = ref<{
  source: string;
  tabs: HubTab[];
  new_imports: NewImportType[];
} | null>(null);
const forbidden = ref(false);

onMounted(async () => {
  const res = await fetch(`${window.location.pathname}/initial_page_data`, {
    method: "GET"
  });

  // A 403 means no readable import type; its body is not page data.
  if (res.status === 403) {
    forbidden.value = true;
    return;
  }
  if (!res.ok) return;

  initialData.value = await res.json();
});
</script>
